
export class OpenaiClient {
  public model: string = 'text-davinci-003';
  public maxTokens: number = 300;
  public temperature: number = 0;
  public apiKey: string = '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';
  public textCompletion: string = '';

  public async fetchDescription(promptStr: string) {

    const axios = require('axios').default;
    let data: any;
    const options = {
      method: 'post',
      url: 'https://api.openai.com/v1/engines/' + this.model + '/completions',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.apiKey,
      },
      data: {
        prompt: promptStr,
        max_tokens: this.maxTokens,
        temperature: this.temperature,
      },
    };

    await axios.request(options).then((response: any) => {
      data = response.data;
    }).catch((error: any) => {
      // do nothing
    });
    return data;
  }

  public async summary(promptStr: string) {

    const axios = require('axios').default;
    let data: any;
    const options = {
      method: 'post',
      url: 'https://api.openai.com/v1/engines/text-davinci-003/completions',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.apiKey,
      },
      data: {
        prompt: 'This is the metrics for a report, select the most 3 important metrics and summarize it to make user understand more about the insight of data, the response format must be in bullet points:' + promptStr,
        max_tokens: this.maxTokens,
        temperature: this.temperature,
      },
    };

    await axios.request(options).then((response: any) => {
      data = response.data;
    }).catch((error: any) => {
      // do nothing
    });
    return data;
  }
}
